import React from 'react';
import { useQuery } from 'react-query';

import { fetchFromFirebase } from '../../hooks/fetchFromFirebase';

// SVG
import { ReactComponent as Facebook } from '../../assets/svg/facebook.svg';
import { ReactComponent as Instagram } from '../../assets/svg/instagram.svg';
import { ReactComponent as Youtube } from '../../assets/svg/youtube.svg';
import { ReactComponent as Twitter } from '../../assets/svg/twitter.svg';
import { ReactComponent as Linkedin } from '../../assets/svg/linkedin.svg';


function ActionBar({ collection, id }) {

    const { isLoading, isError, data, error } = useQuery(['Social Media', collection, id], () => fetchFromFirebase('socialMedia', 'KD6FHhBRkM5ISPT8qTRZ'));
  
    if (isLoading) {
      return <div>Loading...</div>;
    }
  
    if (isError) {
      return <div>Error: {error.message}</div>;
    }

    return (
        <div className="floating-action-bar fixed-mr width-100px blue-bg z-99">
            {data.facebook && (
                <div className="floating-action-item ta-center padding-vert-10 transition-1s pointer">
                    <a href={data.facebook} target="_blank" rel="noreferrer"><Facebook /></a>
                    <div className="white fs-10">Facebook</div>
                </div>
            )}
            {data.instagram && (
                <div className="floating-action-item ta-center padding-vert-10 transition-1s pointer">
                    <a href={data.instagram} target="_blank" rel="noreferrer"><Instagram /></a>
                    <div className="white fs-10">Instagram</div>
                </div>
            )}
            {data.youtube && (
                <div className="floating-action-item ta-center padding-vert-10 transition-1s pointer">
                    <a href={data.youtube} target="_blank" rel="noreferrer"><Youtube /></a>
                    <div className="white fs-10">Youtube</div>
                </div>
            )}
            {data.twitter && (
                <div className="floating-action-item ta-center padding-vert-10 transition-1s pointer">
                    <a href={data.twitter} target="_blank" rel="noreferrer"><Twitter /></a>
                    <div className="white fs-10">Twitter</div>
                </div>
            )}
            {data.linkedin && (
                <div className="floating-action-item ta-center padding-vert-10 transition-1s pointer">
                    <a href={data.linkedin} target="_blank" rel="noreferrer"><Linkedin /></a>
                    <div className="white fs-10">Linkedin</div>
                </div>
            )}
        </div>
    )
}

export default ActionBar;